import React from "react";
import { FaBoxOpen, FaPaintRoller, FaCubes } from "react-icons/fa";
import furnishingBanner from "../assets/banner3.jpg";

export default function FurnishingMaterials() {
  return (
    <div className="MainBodySection py-5" style={{ backgroundColor: "#f9f9f9" }}>
      <div className="container position-relative">
        {/* HEADER */}
        <div className="text-center mb-5">
          <h2 className="main-section-title text-primary">
            Selling & Distribution of Furnishing Materials
          </h2>
          <p className="text-muted fs-6">
            High-quality materials for residential and commercial projects.
          </p>
        </div>

        {/* BANNER IMAGE */}
        <div className="bg-light rounded shadow-sm mb-5 p-3">
          <img
            src={furnishingBanner}
            alt="Furnishing Materials"
            className="img-fluid rounded w-100"
            style={{ maxHeight: 420, objectFit: "cover" }}
          />
        </div>

        {/* SERVICE DESCRIPTION */}
        <div className="bg-white rounded shadow-sm p-4 mb-5">
          <p className="text-muted fs-6 mb-4">
            Kitchen Kings TZ supplies a wide range of furnishing materials sourced from trusted suppliers. Our products cater to both residential and commercial projects, ensuring quality, durability, and ease of customization.
          </p>

          {/* KEY PRODUCTS */}
          <ul className="list-unstyled mb-4">
            <li className="mb-3 d-flex align-items-start">
              <FaBoxOpen size={22} className="me-3 text-primary" />
              <span>Cabinet Handles: Various styles and finishes for any cabinet design.</span>
            </li>
            <li className="mb-3 d-flex align-items-start">
              <FaPaintRoller size={22} className="me-3 text-primary" />
              <span>Sofa Stands: Sturdy bases providing support and aesthetic enhancement.</span>
            </li>
            <li className="mb-3 d-flex align-items-start">
              <FaCubes size={22} className="me-3 text-primary" />
              <span>MDF Boards & Timber: Versatile boards and premium wood for furniture and construction.</span>
            </li>
            <li className="mb-3 d-flex align-items-start">
              <FaCubes size={22} className="me-3 text-primary" />
              <span>Decorative Materials: Trims, moldings, and finishes to elevate your projects.</span>
            </li>
          </ul>

          {/* WORKFLOW / PROCESS */}
          <ol className="fs-6 mb-3">
            <li>Provide high-quality materials for construction and furniture projects.</li>
            <li>Ensure products meet durability, finish, and customization standards.</li>
            <li>Support contractors, interior designers, and DIY enthusiasts with reliable supplies.</li>
          </ol>

          <p className="text-muted fs-6 mt-3">
            Our furnishing materials are designed to make your projects seamless, professional, and visually appealing, whether for home or commercial use.
          </p>
        </div>
      </div>
    </div>
  );
}
